<template>
    <div class="support">
      <div class="supportImgContainer">
        <img class="supportImg" src="@/assets/pgm/support-top.jpg" alt="gsmake support">
      </div>

      <div class="supportInner">
        <h1> FAQ </h1>
<!--        <hr style=" height: 2px; background-color: #2F2F2F;"><br>-->
<!--        <transition-group tag="ul" name="slide">-->
          <div class="question" v-for="(question, i) in questionAnswer" :key="question.id" @click="showAnswer(i)">
            <li style="overflow: hidden"><span style="font-size: 1.8rem;"> Q. </span> {{ question.q }} <span style="overflow: hidden; white-space: nowrap;float: right; padding: 0px 10px" class="fa fa-angle-down fa-2x" aria-hidden="true"></span><br></li>
            <hr style="border: 1px solid #ebebeb;">
              <div class="answer" :class="i == active? activeClass:'hidden'" > <span style="font-size: 1.8rem; color: #e72c02;"> A. </span> {{ question.a }} </div>
          </div>
<!--        </transition-group>-->
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      questionAnswer:[ {q:'I need to get production drawing 2D and 3D data.', a:'Please go to [Product list page and find drawing features]. If you have further inquiry and question, please contact to us.'},
        {q: 'I need to know about small purchase, estimate/period of delivery of GSMAKE product.',a:'If you need small purchase, please contact our sales department.'},
        {q: 'I need to check whether products are (RoHS/REACH/California 65[CP65]).',a:'Please contact our electronic quality division.'},
        {q: 'I need above product introduction list.',a:'For more information, please contact our electronic technical division.'},
        {q: 'I need to know direction to GSMAKE.',a:'Please find the information in contact page or contact us.'},
        {q: 'I need to get test report.',a:'If you purchased our product from our directly, please contact our sales for the information or find our reliability center.'},
        {q: 'I need apply for product samples.',a:'Please contact our sales division for applying product sample procedure.'},
        {q: 'I need unique or customised product.',a:'Please contact our technical or sales division for further information.'}
      ],
      activeClass: 'is-visible',
      active: null
    }
  },
  methods: {
    showAnswer (i) {
      this.active = i;
    }
  },
  components: {
  }
}
</script>

<style scoped>

@font-face {
  font-family:'MuseoSans-300';
  src: url("../../../public/static/font/MuseoSans-300.otf");
}

@font-face {
  font-family:'MuseoSans_700';
  src: url("../../../public/static/font/MuseoSans_700.otf");
}

@font-face {
  font-family: 'font-awesome';
  src: url("../../../public/static/fontAwesome/font-awesome-4.7.0/fonts/FontAwesome.otf");
}

*{
  margin: 0;
  padding: 0;
  font-family: "MuseoSans_700", "font-awesome", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.support {
  width: 100%;
  background-color: #fff;
  height: 1200px;
  float: left;
}

.supportImgContainer {
  padding-top: 89px;
  /*height: 290px;*/
  max-height: 290px;
  max-width: 1900px;
  min-width: auto;
  margin: 0 auto;
  /*float: left;*/
}

.supportImg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.supportInner {
  color: #4a4a4a;
  max-width: 1900px;
  /*min-width: 770px;*/
  margin: 0 auto;
  padding: 4% 2%;
  display: table;
}

h1 {
  font-family: "MuseoSans-300";
  font-size: 3rem;
  letter-spacing: 2px;
  padding-bottom: 10px;
  border-bottom: 3px solid #2F2F2F;
}

.hidden {
  display: none;
  animation-name: slide-out;
  animation-duration: 2s;
}

.is-visible {
  display: block;
  animation-name: slide-in;
  animation-duration: 2s;
  color: #999999;
}

li {
  list-style: none;
  cursor: pointer;
  padding: 15px 0;
}

.question {
  font-size: 1.1rem;
  /*padding: 15px 0;*/
  /*border-bottom: 1px solid #ebebeb;*/
}

.answer {
  padding: 20px 20px 20px 35px;
  background-color: rgb(246, 247, 247);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 1s ease;
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-30px);
  }
}

</style>